import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const { failureToast } = require("views/pages/manage/common/utils/methods/toasterFunctions/function");

export const getAESLslipReferenceDropdown= async(reqObj={})=>{
    const {applicationId,psid,courseId,term,businessArea,bu}=reqObj
    const url = endpoint?.depositSlipReferenceNosByApplication;
    try{
        const req= {
            applicationId,psid,courseId,term,businessArea:businessArea||bu
        }

    const response = await fetchAllPostPromisedData(url, req);
        if (response?.code === 200) {
            return response?.data.map((item) => {
                return {
                    label: item?.depositSlipReferenceNumber,
                    value: item?.depositSlipReferenceNumber
                    , balanceAmount: item?.balanceAmount
                    , depositSlipCreationDate:item?.depositSlipCreationDate
                }
            })
        }
        else{
            failureToast(response?.message)
        }
    }
    catch(error){
        console.log(error)
    }
}

export const getDOIdDropdown =async(applicationId='')=>{
    const url = `${endpoint?.deliveryOrder?.doIdAndVendorDetail}/${applicationId}`;
    try{
    const response = await fetchAllPromisedData(url, true);
        if (response?.code === 200) {
                return [{
                    label: response?.data?.doId, value: response?.data?.doId, loanAmount: response?.data?.netDisbursement,vendorName: response?.data?.vendorName
                }]
        }

    } 
    catch(error){
        console.log(error)
    }
}
export const getAllOnlineVendor =async()=>{
    const url = `${endpoint?.onlineSaleMaster?.getAllOnlineVendor}`;
    try{ 
    const response = await fetchAllPromisedData(url, true);
        if(response?.code===200){
           return  response?.data.map((item)=>{return{label:item?.onlineVendorValue,value:item?.onlineVendorValue}})
        }
        else{
            failureToast(response?.message)
        }
    }
    catch(error){
        console.log(error)
    }
}

export const getAllCardType =async()=>{
    const url = `${endpoint?.cardTypeMaster?.getAllCardType}`;
    try{ 
    const response = await fetchAllPromisedData(url, true);
        if(response?.code===200){
           return  response?.data.map((item)=>{return{label:item?.cardTypeValue,value:item?.id}})
        }
        else{
            failureToast(response?.message)
        }
    }
    catch(error){
        console.log(error)
    }
}

